import { Component, OnDestroy, ViewContainerRef, ViewChild, Compiler } from '@angular/core';
import { FormsModule, ReactiveFormsModule, Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { FormlyModule, FormlyFieldConfig, FormlyBootstrapModule, Field, FieldWrapper } from 'ng-formly';
import { reportService } from './reports.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { WorkflowConfigService } from '../lead/workflowConfig.service';
import { Router } from '@angular/router';
import { LeadService } from '../lead/lead.service';
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';


@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html'
})
export class ReportComponent {

  private myDatePickerOptions: IMyDpOptions = {
    // other options...
    // dateFormat: 'dd.mm.yyyy',
    editableDateField: false,
    inline: false,
    componentDisabled: false,
    disableSince: null

  };

  ProductArray = [];
  CreditSuperVisorArray = [];
  branchList = [];
  searchLeadForm: FormGroup;
  productParent = '';
  productId = '';
  SubProductArray = [];
  defaults: any = {}
  LeadRecords = [];
  searchDataPaging = [];
  searchingData = true;
  indexStart = 0;
  indexEnd = 10;
  pageSize = 5;
  pageNo = 1;
  totalPage = [1];
  isDesc: boolean = false;
  column: any = 'firstName';
  direction: number;
  months;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private leadService: LeadService,
    public toastr: ToastsManager, vcr: ViewContainerRef,
    private _compiler: Compiler,
    private ReportService: reportService,
    private config: WorkflowConfigService,
  ) {
    this.toastr.setRootViewContainerRef(vcr);
    this.searchLeadForm = this.fb.group({
      "ToDate": "",
      "FromDate": "",
      "ProductId": "",
      "SubProductId": "",
      "ApplicationStatus": "",
      "TRN": "",
      "LeadId": "",
      "DateOfBirth": "",
      "CreatedBy": "",
      "BranchId": ""
    });
    var date = new Date().getFullYear();
    this.myDatePickerOptions.disableSince = { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 };

    this.leadService.GetProductList()
      .subscribe(departmentListData => {
        // this.isProductload = true;
        this.ProductArray = departmentListData;
      });

    this.ReportService.GetCreditSupervisors()
      .subscribe(departmentListData => {
        // this.isProductload = true;        
        this.CreditSuperVisorArray = departmentListData;
      });

    this.leadService.fetchBaseBranches()
      .subscribe(departmentListData => {
        this.branchList = departmentListData;
      });

    this.defaults = this.config.defaults();
  }

  ProductChange(str) {
    this.SubProductArray = [];
    //this.isSubProductload = true;
    for (var i = 0; i < this.ProductArray.length; i++) {

      if (this.searchLeadForm.value.ProductId == this.ProductArray[i]["id"]) {
        this.productParent = this.ProductArray[i]["parentName"];
        //this.productParent = "B2B";
      }
    }

    var temp1 = this.search(this.searchLeadForm.value.ProductId, this.ProductArray)
    //this.productId = temp1.id
    this.productId = this.searchLeadForm.value.ProductId
    if (this.productId != "" && this.productId != null) {
      this.leadService.GetSubProductList(this.productId)
        .subscribe(departmentListData => {
          this.SubProductArray = departmentListData;
        });
    }
  }


  search(nameKey, myArray) {
    console.log(this.searchLeadForm.value);
    for (var i = 0; i < myArray.length; i++) {
      if (myArray[i].name === nameKey) {
        return myArray[i];
      }
    }
  }

  searchReports(nameKey, myArray) {
    if (this.searchLeadForm.value.DateOfBirth == undefined || this.searchLeadForm.value.DateOfBirth == null || this.searchLeadForm.value.DateOfBirth == '') {
    }
    else if (typeof this.searchLeadForm.value.DateOfBirth == 'string') {
      this.searchLeadForm.value.DateOfBirth = this.searchLeadForm.value.DateOfBirth;
    }
    else {
      //this.searchLeadForm.value.DateOfBirth = this.searchLeadForm.value.DateOfBirth['date']['year'] + '-' + '0' + this.searchLeadForm.value.DateOfBirth['date']['month'] + '-' + this.searchLeadForm.value.DateOfBirth['date']['day'];
      this.searchLeadForm.value.DateOfBirth = this.searchLeadForm.value.DateOfBirth['date']['year'] + '-' + '0' + this.searchLeadForm.value.DateOfBirth['date']['month'] + '-' + this.searchLeadForm.value.DateOfBirth['date']['day'];
    }

    if (this.searchLeadForm.value.FromDate == undefined || this.searchLeadForm.value.FromDate == null || this.searchLeadForm.value.FromDate == '') {
      this.toastr.error('Please select From Date');
      return;
    }
    else if (typeof this.searchLeadForm.value.FromDate == 'string') {
      this.searchLeadForm.value.FromDate = this.searchLeadForm.value.FromDate;
    }
    else {
      this.searchLeadForm.value.FromDate = this.searchLeadForm.value.FromDate['date']['year'] + '-' + this.searchLeadForm.value.FromDate['date']['month'] + '-' + this.searchLeadForm.value.FromDate['date']['day'];
    }

    if (this.searchLeadForm.value.ToDate == undefined || this.searchLeadForm.value.ToDate == null || this.searchLeadForm.value.ToDate == '') {
      this.toastr.error('Please select To Date');
      return;
    }
    else if (typeof this.searchLeadForm.value.ToDate == 'string') {
      this.searchLeadForm.value.ToDate = this.searchLeadForm.value.ToDate;
    }
    else {
      this.searchLeadForm.value.ToDate = this.searchLeadForm.value.ToDate['date']['year'] + '-' + this.searchLeadForm.value.ToDate['date']['month'] + '-' + this.searchLeadForm.value.ToDate['date']['day'];
    }
    // console.log(this.searchLeadForm.value);

    var monthToDate = this.searchLeadForm.value.ToDate.split('-')[1].length == 1 ? '0' + this.searchLeadForm.value.ToDate.split('-')[1] : this.searchLeadForm.value.ToDate.split('-')[1];
    var dayToDate = this.searchLeadForm.value.ToDate.split('-')[2].length == 1 ? '0' + this.searchLeadForm.value.ToDate.split('-')[2] : this.searchLeadForm.value.ToDate.split('-')[2];
    var formattedToDate = this.searchLeadForm.value.ToDate.split('-')[0] + '-' + monthToDate + '-' + dayToDate;
    var valToDate = new Date(formattedToDate + 'T00:00:00Z');


    var monthFromDate = this.searchLeadForm.value.FromDate.split('-')[1].length == 1 ? '0' + this.searchLeadForm.value.FromDate.split('-')[1] : this.searchLeadForm.value.FromDate.split('-')[1];
    var dayFromDate = this.searchLeadForm.value.FromDate.split('-')[2].length == 1 ? '0' + this.searchLeadForm.value.FromDate.split('-')[2] : this.searchLeadForm.value.FromDate.split('-')[2];
    var formattedFromDate = this.searchLeadForm.value.FromDate.split('-')[0] + '-' + monthFromDate + '-' + dayFromDate;
    var valFromDate = new Date(formattedFromDate + 'T00:00:00Z');

    if (valToDate < valFromDate) {
      this.toastr.error('To Date should be greater than from date.');
      return;
    }

    var date1 = new Date(formattedFromDate + 'T00:00:00Z');
    var date2 = new Date(formattedToDate + 'T00:00:00Z');

    var diffYears = date2.getFullYear() - date1.getFullYear();
    var diffMonths = date2.getMonth() - date1.getMonth();
    var diffDays = date2.getDate() - date1.getDate();

    this.months = (diffYears * 12 + diffMonths);
    if (diffDays > 0) {
      this.months += '.' + diffDays;
    } else if (diffDays < 0) {
      this.months--;
      this.months += '.' + (new Date(date2.getFullYear(), date2.getMonth(), 0).getDate() + diffDays);
    }

    //var differenceDate = new Date(formattedToDate + 'T00:00:00Z') - new Date(formattedFromDate + 'T00:00:00Z');
    if (this.months > 6) {
      this.toastr.error('Difference between from date to To Date should not exceed 6 months.');
      return;
    }


    this.ReportService.searchReports(this.searchLeadForm.value).subscribe((result) => {
      if (result.length > 0) {
        this.LeadRecords = [];
        let LeadRecords1 = [];
        LeadRecords1 = result;
        this.LeadRecords = LeadRecords1;
        this.searchDataPaging = [];
        this.searchingData = false;

        if (this.LeadRecords.length > 5) {
          let j = 1;
          for (var i = 0; i < this.LeadRecords.length; i++) {
            i = i + this.pageSize;
            j = j + 1;
            this.totalPage.push(j);
          }
        }
        for (var i = 0; i < this.LeadRecords.length; i++) {
          let arr: any = [];
          arr = this.LeadRecords[i];
          let rowNum = i;
          arr.applicationNumber = parseInt(arr.applicationNumber)

          this.searchDataPaging.push({ arr, "row": rowNum });
          this.isDesc = true;

        }
        this.sort('leadId');
        this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
        this.indexEnd = 4;
      }
      else {
        this.toastr.info("No lead found.");
        this.searchingData = false;
        this.searchDataPaging = [];
      }
    }, error => {

    });
  }


  sort(property) {
    this.isDesc = !this.isDesc; //change the direction    
    this.column = property;
    this.direction = this.isDesc ? 1 : -1;
  }
  pagingAgent(data) {
    this.pageNo = data;
    this.indexStart = (this.pageNo - 1) * this.pageSize;
    this.indexEnd = (this.pageNo) * this.pageSize - 1;
  }

  changeItemsPerPage(data) {
    if (this.LeadRecords.length > 0) {
      this.totalPage = [1]
      let j = 1;
      for (var i = 0; i < this.LeadRecords.length; i++) {
        i = i + this.pageSize;
        j = j + 1;
        this.totalPage.push(j);
      }
    }
    else {
      this.totalPage = [];
    }
    this.pageSize = data;
    this.indexStart = 0;
    this.indexEnd = this.pageSize - 1;
  }

  download() {
    if (this.searchLeadForm.value.DateOfBirth == undefined || this.searchLeadForm.value.DateOfBirth == null || this.searchLeadForm.value.DateOfBirth == '') {
    }
    else if (typeof this.searchLeadForm.value.DateOfBirth == 'string') {
      this.searchLeadForm.value.DateOfBirth = this.searchLeadForm.value.DateOfBirth;
    }
    else {
      this.searchLeadForm.value.DateOfBirth = this.searchLeadForm.value.DateOfBirth['date']['year'] + '-' + '0' + this.searchLeadForm.value.DateOfBirth['date']['month'] + '-' + this.searchLeadForm.value.DateOfBirth['date']['day'];
    }

    if (this.searchLeadForm.value.FromDate == undefined || this.searchLeadForm.value.FromDate == null || this.searchLeadForm.value.FromDate == '') {
      this.toastr.error('Please select From Date');
      return;
    }
    else if (typeof this.searchLeadForm.value.FromDate == 'string') {
      this.searchLeadForm.value.FromDate = this.searchLeadForm.value.FromDate;
    }
    else {
      this.searchLeadForm.value.FromDate = this.searchLeadForm.value.FromDate['date']['year'] + '-' + this.searchLeadForm.value.FromDate['date']['month'] + '-' + this.searchLeadForm.value.FromDate['date']['day'];
    }

    if (this.searchLeadForm.value.ToDate == undefined || this.searchLeadForm.value.ToDate == null || this.searchLeadForm.value.ToDate == '') {
      this.toastr.error('Please select To Date');
      return;
    }
    else if (typeof this.searchLeadForm.value.ToDate == 'string') {
      this.searchLeadForm.value.ToDate = this.searchLeadForm.value.ToDate;
    }
    else {
      this.searchLeadForm.value.ToDate = this.searchLeadForm.value.ToDate['date']['year'] + '-' + this.searchLeadForm.value.ToDate['date']['month'] + '-' + this.searchLeadForm.value.ToDate['date']['day'];
    }

    var monthToDate = this.searchLeadForm.value.ToDate.split('-')[1].length == 1 ? '0' + this.searchLeadForm.value.ToDate.split('-')[1] : this.searchLeadForm.value.ToDate.split('-')[1];
    var dayToDate = this.searchLeadForm.value.ToDate.split('-')[2].length == 1 ? '0' + this.searchLeadForm.value.ToDate.split('-')[2] : this.searchLeadForm.value.ToDate.split('-')[2];
    var formattedToDate = this.searchLeadForm.value.ToDate.split('-')[0] + '-' + monthToDate + '-' + dayToDate;
    var valToDate = new Date(formattedToDate + 'T00:00:00Z');


    var monthFromDate = this.searchLeadForm.value.FromDate.split('-')[1].length == 1 ? '0' + this.searchLeadForm.value.FromDate.split('-')[1] : this.searchLeadForm.value.FromDate.split('-')[1];
    var dayFromDate = this.searchLeadForm.value.FromDate.split('-')[2].length == 1 ? '0' + this.searchLeadForm.value.FromDate.split('-')[2] : this.searchLeadForm.value.FromDate.split('-')[2];
    var formattedFromDate = this.searchLeadForm.value.FromDate.split('-')[0] + '-' + monthFromDate + '-' + dayFromDate;
    var valFromDate = new Date(formattedFromDate + 'T00:00:00Z');

    if (valToDate < valFromDate) {
      this.toastr.error('To Date should be greater than from date.');
      return;
    }

    var date1 = new Date(formattedFromDate + 'T00:00:00Z');
    var date2 = new Date(formattedToDate + 'T00:00:00Z');

    var diffYears = date2.getFullYear() - date1.getFullYear();
    var diffMonths = date2.getMonth() - date1.getMonth();
    var diffDays = date2.getDate() - date1.getDate();

    this.months = (diffYears * 12 + diffMonths);
    if (diffDays > 0) {
      this.months += '.' + diffDays;
    } else if (diffDays < 0) {
      this.months--;
      this.months += '.' + (new Date(date2.getFullYear(), date2.getMonth(), 0).getDate() + diffDays);
    }

    //var differenceDate = new Date(formattedToDate + 'T00:00:00Z') - new Date(formattedFromDate + 'T00:00:00Z');
    if (this.months > 6) {
      this.toastr.error('Difference between from date to To Date should not exceed 6 months.');
      return;
    }

    console.log(this.searchLeadForm.value);


    this.ReportService.searchReports(this.searchLeadForm.value).subscribe((result) => {
      if (result.length > 0) {

        var csvData = this.ConvertToCSV(result);
        var a = document.createElement("a");
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        var blob = new Blob([csvData], { type: 'text/csv' });
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = 'LeadReports.csv';
        a.click();
      }
      else {
        this.toastr.info("No lead found.");
        this.searchingData = false;
        this.searchDataPaging = [];
      }
    }, error => {

    });
  }

  ConvertToCSV(objArray) {

    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = "";

    for (var index in objArray[0]) {

      //Now convert each value to string and comma-separated
      if (index == "leadFullName") {
        row += 'Lead Name' + ',';
      }
      else if (index == "dateOfBirth") {
        row += 'DateofBirth' + ',';
      }
      else if (index == "productName") {
        row += 'Product' + ',';
      }
      else if (index == "subProductName") {
        row += 'SubProduct' + ',';
      }
      else if (index == "docNumber") {
        row += 'TRN/ DL Num' + ',';
      }
      else if (index == "docType") {
        row += 'ID type' + ',';
      }
      else if (index == "applicationStatus") {
        row += 'ApplicationStatus' + ',';
      }
      else if (index == "applicationDate") {
        row += 'Application Date' + ',';
      }
      else if (index == "createdByName") {
        row += 'Lead Created By' + ',';
      }
      else if (index == "branchName") {
        row += 'Branch' + ',';
      }
      else if (index == "leadCreatedFrom") {
        row += 'Mobile/Browser' + ',';
      }
      else if (index == "sno") {
        row = 'Sno' + ',' + row;
      }
      else if (index == "lastUpdatedby") {
        row += 'Last Updated By' + ',';
      }
      else if (index == "leadId") {
        row += 'Reference num' + ',';
      }
      else if (index == "riskRating") {
        row += 'Risk Rating' + ',';
      }
      else if (index =="otpVerified"){
        row += 'OTP Verified' + ',';
      }
      else {
        row += index + ',';
      }
    }
    row = row.slice(0, -1);
    //append Label row with line break
    str += row + '\r\n';


    for (var i = 0; i < array.length; i++) {
      var line = '';
      for (var index in array[i]) {       
        if (index == "sno") {
          line = array[i][index]  + line;
        }
        else {
          //if (line != '') line += ',';
          line += ','
          line += array[i][index];
        }

      }
      str += line + '\r\n';
    }
    return str;
  }

}







// WEBPACK FOOTER //
// ./src/app/Reports/reports.component.ts